import { useState } from 'react';

/**
 * Gestion des prévisualisations d'une demande :
 * ajout (URL + libellé), suppression, définition de la preview finale.
 * La « finale » est identifiée par l'id de la preview (finalPreviewId), avec
 * rétrocompat par URL pour les anciennes previews sans id.
 */
const PreviewsManager = ({ previews, finalPreviewUrl, finalPreviewId, onAdd, onRemove, onSetFinal, isAdding }) => {
  const [url, setUrl] = useState('');
  const [label, setLabel] = useState('');
  const [error, setError] = useState(null);

  const handleAdd = (e) => {
    e.preventDefault();
    if (!url.trim()) {
      setError('L\'URL est requise.');
      return;
    }
    setError(null);
    onAdd({ url: url.trim(), label: label.trim() });
    setUrl('');
    setLabel('');
  };

  return (
    <div className="space-y-4">
      <form onSubmit={handleAdd} className="space-y-2">
        <input
          type="url"
          className="input input-bordered input-sm w-full"
          placeholder="URL de la prévisualisation"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <div className="flex gap-2">
          <input
            type="text"
            className="input input-bordered input-sm flex-1"
            placeholder="Libellé (ex : Version 1)"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />
          <button type="submit" className="btn btn-primary btn-sm" disabled={isAdding}>
            {isAdding ? 'Ajout...' : 'Ajouter'}
          </button>
        </div>
        {error && <p className="text-xs text-error">{error}</p>}
      </form>

      {previews.length === 0 && (
        <p className="text-xs text-base-content/50 italic">Aucune prévisualisation pour le moment.</p>
      )}
      <div className="space-y-2">
        {previews.map((p, index) => {
          const isFinal = (p.id && finalPreviewId === p.id) || (!p.id && finalPreviewUrl === p.url);
          return (
            <div key={p.id || p.url || index} className="flex items-center gap-3 border border-base-200 rounded-lg p-2">
              <a href={p.url} target="_blank" rel="noopener noreferrer" className="flex-1 min-w-0">
                <span className="block text-sm font-medium truncate">{p.label || `Prévisualisation ${index + 1}`}</span>
                <span className="block text-xs text-base-content/50 truncate">{p.url}</span>
              </a>
              <button
                type="button"
                className="btn btn-xs btn-outline"
                onClick={() => onSetFinal(p.id || p.url)}
                title="Définir comme preview finale"
              >
                {isFinal ? '✓ Finale' : 'Définir finale'}
              </button>
              <button type="button" className="btn btn-xs btn-ghost text-error" onClick={() => onRemove(index)}>
                ✕
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PreviewsManager;
